import CopyText from './Input';

export default CopyText;
